import axios from "axios";
export const fetchArticles = async (key, pageNo = 1, perPage = 10) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            "https://journalapi.rhc.ac.ir/Admin/GetArticleS",
            {
                articleStatus: key,
                journalId: 1,
                pageNo: pageNo,
                perPage: perPage,
                keyword: "",
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
       // console.log(token) ;
       localStorage.setItem("token", response.data.meta.token);
       console.log(response.data.meta.token) ;

        return response.data;
    } catch (error) {
        console.error("Axios error:", error.response?.data || error.message);
        //throw error;

    }
};

export const fetchArticleDetails = async (articleId) => {
  try {
    const token = localStorage.getItem("token");

      const response = await axios.post(
          "https://journalapi.rhc.ac.ir/Admin/GetArticle",
          {
            articleId : articleId

          },
          {
            headers: {
                Authorization: `Bearer ${token}`,
            },
          }
      );
      localStorage.setItem("token", response.data.meta.token);
      console.log(response.data.meta.token) ;

      return response.data.data;
  } catch (error) {
      console.error("Axios error:", error.response?.data || error.message);
      //throw error;

  }
};

export const fetchArticleSteps = async (articleId) => {
  try {
    const token = localStorage.getItem("token");

      const response = await axios.post(
          "https://journalapi.rhc.ac.ir/Admin/GetArticleStepS",
          {
            articleId : articleId

          },
          {
            headers: {
                Authorization: `Bearer ${token}`,
            },
          }
      );
      localStorage.setItem("token", response.data.meta.token);
      console.log(response.data.meta.token) ;

    return response.data.data;
  } catch (error) {
      console.error("Axios error:", error.response?.data || error.message);
      throw error;

  }
};

export const getArticleStepReviewer = async (articleId) => {
  try {
    const token = localStorage.getItem("token");

      const response = await axios.post(
          "https://journalapi.rhc.ac.ir/Admin/GetArticleStepReviewer",
          {
            articleId : articleId

          },
          {
            headers: {
                Authorization: `Bearer ${token}`,
            },
          }
      );
      localStorage.setItem("token", response.data.meta.token);
      console.log("reviewers:" ,response.data) ;

    return response.data;
  } catch (error) {
      console.error("Axios error:", error.response?.data || error.message);
      //throw error;

  }
};

export const DeleteArticleReviewer = async (articleId,reviewerId) => {
  try {
    const token = localStorage.getItem("token");

      const response = await axios.post(
          "https://journalapi.rhc.ac.ir/Admin/DeleteArticleReviewer",
          {
            articleId : articleId ,
            reviewerId : reviewerId
          },
          {
            headers: {
                Authorization: `Bearer ${token}`,
            },
          }
      );
      localStorage.setItem("token", response.data.meta.token);
      console.log("reviewers:" ,response.data) ;

    return response.data;
  } catch (error) {
      console.error("Axios error:", error.response?.data || error.message);
      //throw error;

  }
};


export const uploadPdfArticle = async (formData) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/UploadPDFArticle",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log("reviewers:", response.data);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    //throw error;
  }
};
